"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEGMENT = exports.COMPONENT_NAME = exports.C2C_COLORS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.constants");
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-atencion-emp"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./CallMeBackFloatingEmp.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const SEGMENT = exports.SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
const C2C_COLORS = exports.C2C_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  CORAL: 'coral',
  AMBAR: 'ambar',
  GrEY2: 'grey2'
};
const COMPONENT_NAME = exports.COMPONENT_NAME = 'ContactCircle';
const CallMeBackFloatingEmp = props => {
  const {
    Modal,
    flotanteProps,
    SvgIconLoader,
    modalAtencionConfig,
    visible
  } = props;
  let {
    taggingInfo
  } = props;
  const {
    iconId,
    iconSize,
    iconSegment,
    iconKind,
    iconColor,
    labelColor,
    labelText,
    labelSize,
    backgroundColor,
    desktopContainerBottom,
    mobileContainerBottom,
    title,
    option
  } = flotanteProps;
  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: flotanteProps.campaign || 'all',
      componentName: COMPONENT_NAME,
      componentProduct: ''
    };
  }
  const containerRootClass = 'clickToCall';
  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false
    });
  };
  const handleNewModal = item => {
    setUpModalProps();
    Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
      Modal: Modal,
      taggingInfo: _objectSpread({}, taggingInfo),
      SvgIconLoader: SvgIconLoader,
      campaign: item.campaign,
      product: `Interes ${item.product}`,
      tabsOptions: _objectSpread(_objectSpread({}, modalAtencionConfig), {}, {
        tabOptionPreChecked: item.option
      })
    }));
    return Modal.show();
  };
  const generateClassNameWithColor = (className, color, defaultColor = C2C_COLORS.WHITE) => {
    let classColor = defaultColor;
    const colorExist = Object.values(C2C_COLORS).find(c => c === color);
    if (colorExist) {
      classColor = colorExist;
    }
    return `${className} ${className}_${classColor}`;
  };
  const getBottomNumberByDevice = (desktopTop, mobileTop) => {
    const device = (0, _gerenciatdUtils.getDeviceKindDependsOnViewPort)();
    if (device === _gerenciatdUtils2.DEVICES.PC) {
      if (Number.isInteger(desktopTop)) {
        return desktopTop;
      }
    } else if (Number.isInteger(mobileTop)) {
      return mobileTop;
    }
    return 0;
  };
  const desktopContainerBottomAux = desktopContainerBottom || 107;
  const mobileContainerBottomAux = mobileContainerBottom || 75;
  const wrapper = {
    bottom: `${getBottomNumberByDevice(desktopContainerBottomAux, mobileContainerBottomAux)}px`
  };
  const componentContainerClass = (0, _react.useMemo)(() => generateClassNameWithColor(containerRootClass, backgroundColor, C2C_COLORS.CORAL), [backgroundColor]);
  const renderLinkWithModal = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "transparent-background",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
        segment: iconSegment,
        id: iconId,
        kind: iconKind,
        size: iconSize,
        color: iconColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        kind: "span",
        size: "caption01",
        text: labelText,
        fontType: "font-regular",
        color: labelColor,
        segment: iconSegment,
        className: "flotante-txt"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
        segment: iconSegment,
        id: "CheuronRight",
        kind: "M",
        size: 16,
        color: iconColor,
        className: "flotante-cheuron"
      })]
    });
  };
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: componentContainerClass,
    style: wrapper,
    children: [renderLinkWithModal(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
      isBlockElement: true,
      onClick: () => {
        handleNewModal(flotanteProps);
      },
      accInfo: {
        title: title || 'Te llamamos'
      },
      taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentContent: `${option}-flotante`,
        componentVariation: flotanteProps.campaign || 'all'
      })
    })]
  });
};
CallMeBackFloatingEmp.defaultProps = {
  visible: true,
  segment: SEGMENT.EMP,
  flotanteProps: {
    iconId: 'Fijo',
    iconKind: 'M',
    iconSize: 31,
    iconColor: 'grey6',
    iconSegment: 'emp',
    desktopContainerTop: 418,
    mobileContainerTop: 256,
    desktopContainerBottom: 107,
    mobileContainerBottom: 75,
    backgroundColor: 'ambar',
    title: 'Te llamamos'
  }
};
CallMeBackFloatingEmp.propTypes = {
  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: _propTypes.default.oneOf([SEGMENT.GP, SEGMENT.EMP]),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,
  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: _propTypes.default.bool,
  flotanteProps: _propTypes.default.shape({
    iconId: _propTypes.default.string.isRequired,
    iconKind: _propTypes.default.string.isRequired,
    iconSize: _propTypes.default.number.isRequired,
    iconColor: _propTypes.default.string.isRequired,
    iconSegment: _propTypes.default.oneOf(SEGMENT).isRequired,
    desktopContainerTop: _propTypes.default.number.isRequired,
    mobileContainerTop: _propTypes.default.number.isRequired,
    desktopContainerBottom: _propTypes.default.number.isRequired,
    mobileContainerBottom: _propTypes.default.number.isRequired,
    iconContainerColor: _propTypes.default.oneOf(C2C_COLORS).isRequired,
    backgroundColor: _propTypes.default.oneOf(C2C_COLORS).isRequired,
    title: _propTypes.default.string.isRequired
  }),
  Modal: _propTypes.default.func.isRequired,
  // Para cambiarle el producto que enviara el formulario
  fixedProduct: _propTypes.default.string,
  // Para setearle una campaña al formulario distinta de la que pueda dar SCX
  fixedCampaign: _propTypes.default.string
};
var _default = exports.default = CallMeBackFloatingEmp;

//# sourceMappingURL=index.js.map